var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2276_948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5108 13.2705L16.5106 13.2704L5.82627 4.25192L5.8262 4.25186C5.40048 3.89246 4.82964 3.91271 4.41377 4.34589C3.96652 4.81632 3.86106 5.63856 4.21967 6.26389L11.5181 18.9598L11.519 18.9614C11.9711 19.751 12.639 20.2902 13.3699 20.5371L17.8692 15.9803C17.7655 14.8837 17.2631 13.9053 16.5108 13.2705ZM20.1812 18.6723L15.5558 23.3515L14.5647 22.9316C14.5602 23.0129 14.5557 23.1855 14.5557 23.3125C14.5557 26.4559 16.8171 29 19.6112 29H26.1112C26.9088 29 27.5557 28.2738 27.5557 27.375C27.5557 26.4762 26.9088 25.75 26.1112 25.75H25.8941C25.0983 25.75 24.5584 24.7902 24.6401 23.9016L23.6443 23.8107C23.6443 23.8105 23.6443 23.8102 23.6443 23.81C23.6591 23.6478 23.6668 23.4803 23.6668 23.3125C23.6668 20.8551 22.0694 18.9844 20.1812 18.6723Z",
    stroke: "#828282",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2276_948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "matrix(-1 0 0 1 29 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/MediumIcon.a96249095c9eb6ef78cf4babbe698390.svg";
export { ForwardRef as ReactComponent };